module.exports = __webpack_public_path__ + "static/media/profil.05791676.png";